module.exports = __webpack_public_path__ + "static/media/PDF_94.7fc3e163.pdf";